/** Remember-me helpers — stores identifier (email/username) only, never passwords. */

export function loadRememberedLogin(prefix) {
  const rememberMe = localStorage.getItem(`${prefix}_REMEMBER_ME`) === "true";
  const identifier = localStorage.getItem(`${prefix}_REMEMBERED_IDENTIFIER`) || "";
  return { rememberMe, identifier };
}

export function onRememberMeToggle(prefix, checked, setRememberMe) {
  setRememberMe(checked);
  localStorage.setItem(`${prefix}_REMEMBER_ME`, String(checked));
  if (!checked) {
    localStorage.removeItem(`${prefix}_REMEMBERED_IDENTIFIER`);
  }
}

export function persistRememberedLogin(prefix, rememberMe, identifier) {
  localStorage.setItem(`${prefix}_REMEMBER_ME`, String(rememberMe));
  if (rememberMe && identifier) {
    localStorage.setItem(`${prefix}_REMEMBERED_IDENTIFIER`, identifier);
  } else {
    localStorage.removeItem(`${prefix}_REMEMBERED_IDENTIFIER`);
  }
}

/** Migrate legacy unprefixed keys into a namespaced prefix. */
export function migrateLegacyRememberMe(prefix, legacyRememberKey, legacyIdentifierKey) {
  if (localStorage.getItem(`${prefix}_REMEMBER_ME`) != null) return;
  const legacyRemember = localStorage.getItem(legacyRememberKey);
  if (legacyRemember == null) return;
  localStorage.setItem(`${prefix}_REMEMBER_ME`, legacyRemember);
  const legacyId = localStorage.getItem(legacyIdentifierKey);
  if (legacyId) {
    localStorage.setItem(`${prefix}_REMEMBERED_IDENTIFIER`, legacyId);
  }
}
